// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ceWw","col":"styles_col__2lcJm"};